import { useSuggestSearchSupport } from './hopps';

export function useSearchEngine() {
    return useSuggestSearchSupport();
}
